/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingWalletType
 */
export interface BillingWalletType {
    /**
     * 
     * @type {number}
     * @memberof BillingWalletType
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingWalletType
     */
    name: BillingWalletTypeNameEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingWalletType
     */
    fundingMode: BillingWalletTypeFundingModeEnum;
}

/**
* @export
* @enum {string}
*/
export enum BillingWalletTypeNameEnum {
    SmsCredits = 'SMS Credits',
    ReferralCredits = 'Referral Credits'
}
/**
* @export
* @enum {string}
*/
export enum BillingWalletTypeFundingModeEnum {
    TopUp = 'Top-Up',
    Credits = 'Credits'
}


/**
 * Check if a given object implements the BillingWalletType interface.
 */
export function instanceOfBillingWalletType(value: object): value is BillingWalletType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fundingMode' in value) || value['fundingMode'] === undefined) return false;
    return true;
}

export function BillingWalletTypeFromJSON(json: any): BillingWalletType {
    return BillingWalletTypeFromJSONTyped(json, false);
}

export function BillingWalletTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingWalletType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'fundingMode': json['fundingMode'],
    };
}

  export function BillingWalletTypeToJSON(json: any): BillingWalletType {
      return BillingWalletTypeToJSONTyped(json, false);
  }

  export function BillingWalletTypeToJSONTyped(value?: BillingWalletType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'fundingMode': value['fundingMode'],
    };
}

